/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bicycle_medium'
export default icon
